module.exports = __webpack_public_path__ + "assets/img/sukikamolist_homebtn.d7d746ba.svg";